import React, { useEffect, useState } from 'react';
import { Markup } from 'interweave';
import { useAuth } from '../../../../hooks/useAuth';

// Posters dos videos tutoriais

import posterSharePublications from './img/poster-share-publications.png';
import posterMoney from './img/poster-money.png';
import posterHowTo from './img/posterHowTo.png';

// Fim Posters dos videos tutoriais

import './style.css';

export default function OnboardingSection() {
  const { player } = useAuth();

  const [videosTutorials, setVideosTutorials] = useState([]);

  useEffect(() => {
    const videosTutorialsStatic = [
      {
        url: 'https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/completo.mp4?alt=media&token=04cd25b5-eb4c-4d81-ad8b-f65d70fcb81d',
        title: 'Como compartilhar uma publicação?',
        shortDescription: 'Veja como é fácil compartilhar uma publicação.',
        description:
          'Veja como é fácil compartilhar uma publicação. São apenas 3 passos simples:<br><br>1 - Escolha o que você quer compartilhar;<br>2 - Clique em uma das opções de compartilhamento;<br>3 - Publique ou envie o link para quantas pessoas ou grupos quiser;<br><br>Você pode ver mais detalhes clicando na publicação.',
        poster: posterSharePublications,
        active: true,
      },
      {
        url: 'https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/resgate%20dinheiro.mp4?alt=media&token=1ce9af09-78b8-4119-a1e9-e6daaed4e919',
        title: 'Como resgatar dinheiro?',
        shortDescription: 'Veja como é fácil resgatar dinheiro.',
        description:
          'Veja como é fácil resgatar dinheiro. São apenas alguns passos simples.<br><br>Siga o passo a passo e explicamos no video tutorial e resgate prêmios em dinheiro sem complicações.',
        poster: posterMoney,
        active: true,
      },
    ];

    if (player && player.regional === 'sim') {
      videosTutorialsStatic.push({
        url: 'https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/videocorretor.mp4?alt=media&token=7f0b6402-cc29-4c4b-8991-19e29d70b117',
        title: 'Quais as vantagens tenho em participar?',
        shortDescription: 'Veja quais as vantagens em participar do programa.',
        description:
          'Veja quais as vantagens em participar do programa. Entenda de uma vez por todas como funciona todo ciclo de propecção, indicação, compartilhamento, recompensas e muito mais.',
        poster: posterHowTo,
        active: true,
      });
      setVideosTutorials(videosTutorialsStatic);
    } else {
      setVideosTutorials(videosTutorialsStatic);
    }
  }, []);

  const [initialIndexTutorial, setInitialIndexTutorial] = useState(0);

  function activeTutorial(e) {
    const cardElement = document.querySelectorAll('.oq-item-tutorial');
    cardElement.forEach((element) => {
      element.classList.remove('active');
    });
    e.currentTarget.classList.add('active');
    setInitialIndexTutorial(e.currentTarget.dataset.index);
  }

  return (
    <>
      {videosTutorials.length > 0 && (
        <div className="row">
          <div className="col-sm-12 col-md-8">
            <div className="ob-how-to-card-group">
              <div className="ob-how-to-responsive-video">
                <video
                  src={videosTutorials[initialIndexTutorial].url}
                  poster={videosTutorials[initialIndexTutorial].poster}
                  controls
                  preload="auto"
                ></video>
              </div>
              <div className="ob-how-to-card video-header">
                <h2>{videosTutorials[initialIndexTutorial].title}</h2>
                <p>
                  <Markup
                    content={videosTutorials[initialIndexTutorial].description}
                  />
                </p>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-4">
            <div className="ob-how-to-card-group">
              <div className="ob-how-to-card header">
                <h2>Videos tutoriais</h2>
                <p className="">
                  A lista abaixo ajudará você a utilizar nossa plataforma de
                  maneira simples. São videos curtos e objetivos. Acesse quando
                  quiser.
                </p>
              </div>
              {videosTutorials.map((video, index) => {
                if (video.active) {
                  return (
                    <div
                      className={
                        index === 0
                          ? 'ob-how-to-card oq-item-tutorial active'
                          : 'ob-how-to-card oq-item-tutorial'
                      }
                      data-index={index}
                      onClick={(e) => {
                        activeTutorial(e);
                      }}
                    >
                      <span className="ob-how-to-card-title">
                        <i className="material-icons-outlined">play_arrow</i>{' '}
                        {video.title}
                      </span>
                      <p className="ob-how-to-content-item-description">
                        {video.shortDescription}
                      </p>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
